import { FC } from 'react';
import { DagStatus } from '@agilelab/plugin-wb-builder-common';
import { TestStatus } from '@agilelab/plugin-wb-platform';
import { TableCell, TableRow, Typography } from '@material-ui/core';
import { format, parseISO } from 'date-fns';

interface Props {
  loadingText?: string;
  startDate?: string;
  isLoading?: boolean;
}

export const TestTableLoadingRow: FC<Props> = ({
  loadingText = 'Loading...',
  startDate = new Date().toISOString(),
  isLoading = true,
}) => {
  return (
    <TableRow>
      <TableCell width="5%">
        <TestStatus
          status={isLoading ? DagStatus.RUNNING : DagStatus.COMPLETED}
          variant="reduced"
        />
      </TableCell>
      <TableCell width="40%">
        <Typography>
          Started at: {format(parseISO(startDate), 'yyyy/MM/dd HH:mm:ss')}
        </Typography>
      </TableCell>
      <TableCell colSpan={2} width="45%">
        <Typography>{loadingText}</Typography>
      </TableCell>
    </TableRow>
  );
};
